/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Weak_PasswordInputs */



/**
* | output |
* | --- |
* | "Please choose a stronger password." |
*
* @param {Login_Error_Weak_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_weak_password = /** @type {((inputs?: Login_Error_Weak_PasswordInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Weak_PasswordInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez choisir un mot de passe plus fort.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie ein sichereres Passwort.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli una password più sicura.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите более надежный пароль.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elija una contraseña más segura.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择更强的密码。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("より強力なパスワードを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया अधिक मजबूत पासवर्ड चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, escolha uma senha mais forte.")
	return /** @type {LocalizedString} */ ("Please choose a stronger password.")
});